/** Angular Imports */
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

/** rxjs Imports */
import { Observable } from 'rxjs';
import { SelectedCurrencyOption } from 'app/model/savingsaccounttransctiontemplate';

/**
 * Home Service
 */
@Injectable({
  providedIn: 'root'
})
export class HomeService {

  /**
   * @param {HttpClient} http Http Client to send requests.
   */
  constructor(private http: HttpClient) { }


    /**
   * @returns {Observable<any>}
   */
     getTellerForUser(): Observable<any> {

      return this.http.get(`/tellers/assigned-teller`);
    }

 /**
  * 
  * @param id Id of teller to to start operation for
  * @param action start or close command to start or stop teller
  * @returns Observable returned on start
  */
    tellerAction(id: any, action: any): Observable<any> {
      const data = {}; 
      const httpParams = new HttpParams().set('command', action);
      return this.http.post(`/tellers/${id}`,data, { params: httpParams });
    }

    getCurrencies<SelectedCurrencyOptions>(){
      const httpParams = new HttpParams().set('fields','selectedCurrencyOptions')
      return this.http.get<SelectedCurrencyOptions>(`/currencies`,{params: httpParams})
    }

}
